export const getTopCountriesFiltersByTimeRange = (timeRange, filters) => {
  if (timeRange === 'custom') {
    return {
      timeRange,
      startDate: filters.startDate,
      endDate: filters.endDate,
    }
  }

  return {
    timeRange,
  }
}
